import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

const ExamityRequirements = observer(class ExamityRequirements extends React.Component {
  render() {
    const { translation } = this.props;

    return (
      <div className="text-block">
        <strong>{translation.chromebook_warning}</strong>
      </div>
    )
  }
})

export default translate('ExamityRequirements')(ExamityRequirements);



// WEBPACK FOOTER //
// ./src/app/components/StudentDashboard/ExamityRequirements.js